import React, { useEffect, useState } from 'react';
import { ToggleListStyles } from './ToggleListStyles';
import { IOption, IOptionData, modeStateType } from '../../_types';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import { RALColors } from '../../_data';
import { enqueueSnackbar } from 'notistack';

const ToggleList = ({
  option,
  type,
  modelState,
  value,
  handleUpdateState,
}: {
  option: IOption;
  type: string;
  modelState: modeStateType;
  value: keyof modeStateType;
  handleUpdateState: (
    valueName: keyof modeStateType,
    valueData: string | number | boolean,
    file?: File
  ) => void;
}) => {
  const [isEnabled, setIsEnabled] = useState<boolean>(false);
  const [colorValue, setColorValue] = useState<string>('');
  const handleChangeValue = (
    // valueName: keyof modeStateType,
    valueData: string | number
  ) => {
    handleUpdateState(value, valueData);
    // if (
    //   (modelState.model === "basic" || modelState.model === "fullPanoramic") &&
    //   modelState.personalizedCorners
    // ) {
    //   setIsEnabled(false);
    //   handleUpdateState("personalizedCorners", false);
    // } else if (valueData === "fullPanoramic") {
    //   handleUpdateState("interior", true);
    // }
  };

  useEffect(() => {
    if (modelState.model === 'fullPanoramic' && value === 'interior') {
      setIsEnabled(true);
      handleUpdateState('interior', true);
    }
    // if (value === "personalizedCorners") {
    //   console.log(modelState.model);
    //   console.log(isEnabled);
    // }
    if (
      (modelState.model === 'visionCorner' ||
        modelState.model === 'fullPanoramic') &&
      value === 'personalizedCorners'
    ) {
      setIsEnabled(false);
      handleUpdateState('personalizedCorners', false);
    }
  }, [modelState.model]);

  const handleToggle = () => {
    if (!(value === 'interior' && modelState.model === 'fullPanoramic')) {
      handleUpdateState(value, !isEnabled);
      setIsEnabled(() => !isEnabled);
    }
  };

  const handleCheckedChange = (
    // e: React.ChangeEvent<HTMLInputElement>,
    listName: keyof modeStateType,
    value: string | number
  ) => {
    handleUpdateState(listName, value);
    // if (listName === 'protection') {
    //   let clonedProtection = [...modelState.protection];
    //   const index = clonedProtection.findIndex((val) => val === value);
    //   if (index > -1) {
    //     clonedProtection.splice(index, 1);
    //   } else {
    //     clonedProtection.push(value);
    //   }
    //   handleUpdateState(listName, value);
    // }
  };

  const handleChangeImage = (
    e: React.ChangeEvent<HTMLInputElement>,
    optionValue: keyof modeStateType
  ) => {
    if (e.target.files && e.target.files[0]) {
      const url: string = URL.createObjectURL(e.target.files[0]);
      if (value === 'personalizedCorners') {
        handleUpdateState('personalizedCornersImage', url, e.target.files[0]);
      }
      // else if (value === 'personalizedNet') {
      //   handleUpdateState('personalizedNetImage', url, e.target.files[0]);
      // }
    }
  };

  const handleApplyColor = (colorValue: string) => {
    let flag = false;
    if (colorValue) {
      RALColors.forEach((RALColor) => {
        if (RALColor.name === colorValue.trim()) {
          handleUpdateState(value, RALColor.hexValue);
          flag = true;
        }
      });
      if (!flag) {
        enqueueSnackbar('Please enter the correct RAL color code', {
          variant: 'warning',
          autoHideDuration: 3000,
          preventDuplicate: true,
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
        });
      }
    }
  };

  if (type === 'colorOption') {
    return (
      <ToggleListStyles type={type} className={`toggle__main`}>
        <Tooltip anchorSelect=".my-anchor-element" />
        {option?.data?.map((data: IOptionData) => {
          return (
            <div
              onClick={() => handleChangeValue(data.value)}
              key={data?.name}
              className="toggle__option__container"
            >
              <div
                style={
                  data?.value && typeof data?.value === 'string'
                    ? { backgroundColor: data?.value }
                    : {}
                }
                className="color__container my-anchor-element"
                data-tooltip-content={data?.name}
              >
                {modelState[value] === data.value && (
                  <div className="icon__check__container">
                    <i className="fa-solid fa-check icon__check"></i>
                  </div>
                )}
              </div>
            </div>
          );
        })}
        {value === 'frameColor' && (
          <>
            <div className="inputColorContainer">
              <label
                className="label__color__input"
                htmlFor={value + 'InputColor'}
              >
                RAL Color:{' '}
              </label>
              <input
                value={colorValue}
                placeholder="RAL 3007"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setColorValue(e.target.value)
                }
                id={value + 'InputColor'}
                className="colorInput"
              />
              <button
                onClick={() => handleApplyColor(colorValue)}
                className="btn__apply__color"
              >
                Apply
              </button>
            </div>
            <div className="color__reference">
              <a
                target="_blank"
                rel="noreferrer"
                href="https://www.ralcolor.com/"
              >
                RAL Color Reference link
              </a>
            </div>
          </>
        )}
        {/* <div className="toggle__option__container">
          <div className="color__container">
            <input
              onChange={(e) => handleChangeValue(e.target.value)}
              className="input__color my-anchor-element"
              data-tooltip-content="color picker"
              type="color"
            />
          </div>
        </div> */}
      </ToggleListStyles>
    );
  } else if (type === 'imageOption-3') {
    return (
      <ToggleListStyles type={type} className={`toggle__main`}>
        <Tooltip anchorSelect=".my-anchor-element" />
        {option?.data?.map((data: IOptionData) => {
          return (
            <div
              onClick={() => handleChangeValue(data.value)}
              key={data?.name}
              className="toggle__option__container"
            >
              <div
                style={value === 'grassType' ? { border: 'none' } : {}}
                className="image__container my-anchor-element"
                data-tooltip-content={data?.name}
              >
                <img src={data?.image} alt="" />
                {modelState[value] === data.value && (
                  <div className="icon__check__container">
                    <i className="fa-solid fa-check icon__check"></i>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </ToggleListStyles>
    );
  } else if (type === 'toggle-1') {
    return (
      <ToggleListStyles type={type} className={`toggle__main`}>
        <div className="toggle__option__container">
          <div className="right__container__toggle">
            <label htmlFor={option?.name}>{option?.name}</label>
            <Toggle
              checked={isEnabled}
              onChange={() => handleToggle()}
              id={option?.name}
            />
          </div>
        </div>
        {/* {modelState[value] && value === 'personalizedCorners' ? ( */}
        <div
          className={`upload__container toggle__option__container ${
            modelState[value] && value === 'personalizedCorners' ? '' : 'hidden'
          }`}
        >
          <input
            onChange={(e) => handleChangeImage(e, option.value)}
            type="file"
            accept=".jpg, .jpeg, .png, .svg, .webp"
          />
        </div>
        {/* ) : (
          ''
        )} */}
      </ToggleListStyles>
    );
  } else if (type === 'multi-dropdown') {
    return (
      <ToggleListStyles type={type} className={`toggle__main`}>
        <div className="toggle__container__value">
          <label></label>
          <span
            onClick={
              modelState.protection.length
                ? () => handleCheckedChange(option.value, 'none')
                : () => handleCheckedChange(option.value, 'all')
            }
            className="all__check"
          >
            {modelState.protection.length ? (
              <i
                style={{ color: '#e34747' }}
                className="fa-regular fa-circle-xmark"
              ></i>
            ) : (
              <i
                style={{ color: '#0075ff' }}
                className="fa-regular fa-circle-check"
              ></i>
            )}
          </span>
        </div>
        {option?.data?.map((data: IOptionData) => {
          return (
            <div key={data?.name} className="toggle__option__container">
              <div className="toggle__container__value">
                <label htmlFor={data.name}>{data.name}</label>
                <input
                  checked={
                    option.value === 'protection'
                      ? modelState[option.value].findIndex(
                          (val) => data.value === val
                        ) > -1
                        ? true
                        : false
                      : false
                  }
                  onChange={() => handleCheckedChange(option.value, data.value)}
                  id={data.name}
                  className="input__checkbox"
                  type="checkbox"
                />
              </div>
            </div>
          );
        })}
      </ToggleListStyles>
    );
  } else {
    return (
      <ToggleListStyles type={type} className={`toggle__main`}>
        {option?.data?.map((data: IOptionData) => {
          return (
            <div
              key={data?.name}
              onClick={() => handleChangeValue(data.value)}
              className="toggle__option__container"
            >
              <div className="image__container">
                <img className="image" src={data?.image} alt="" />
              </div>
              <div className="right__container">
                <div className="text">{data?.name}</div>
                {value === 'model' && modelState.model === data.value ? (
                  <div className="icon__container">
                    <i className="fa-solid fa-check"></i>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          );
        })}
      </ToggleListStyles>
    );
  }
};

export default ToggleList;
